import { render, staticRenderFns } from "./FiatPix.vue?vue&type=template&id=70df6c6d"
import script from "./FiatPix.vue?vue&type=script&lang=js"
export * from "./FiatPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports